import { useMutation } from '@tanstack/react-query';
import apiService from './apiServices';
import apiServiceNoToast from './apiServicesNoToast';
import { apiServiceRTQ } from './apiShow';
import { showToast } from '@/utils/toastMessage/ToastMessage';
/**
 * Provides functions to update data on the server.
 */
export const UpdateAllData = {
  /**
   * Updates data at the given URL with the provided values.
   *
   * @param {string} url - The URL to update data at.
   * @param {Object} values - The values to update the data with.
   * @returns {Promise<Object>} A promise that resolves to the updated data.
   */
  updateData: async (url, values) => {
    return await apiServiceRTQ.patch(url, values);
  },
};

export const useUpdateApi = () => {
  return useMutation({
    mutationFn: ({ url, values, options }) =>
      apiServiceRTQ.patch(url, values, options),
    onSuccess: (data) => {
      showToast(data?.response, 'success');
    },
    onError: (error) => {
      console.warn('Update error:', error);
    },
  });
};

export const useUpdateApiNoToast = () => {
  return useMutation({
    mutationFn: ({ url, values, options }) =>
      apiServiceRTQ.patch(url, values, options),
    onSuccess: () => {},
    onError: (error) => {
      console.warn('Update error:', error);
    },
  });
};
